
import React from 'react';
import { Link } from 'react-router-dom';
import { ICONS } from '../constants';

interface ServiceItemProps {
  id: string;
  title: string;
  description: string;
  metric: string;
  icon: React.ReactNode;
  span?: string;
}

export const ServiceItem: React.FC<ServiceItemProps> = ({ id, title, description, metric, icon, span }) => (
  <div className={`${span || ''} p-12 rounded-[3rem] glass-card infrastructure-border group hover:-translate-y-2 transition-all duration-500 flex flex-col justify-between relative overflow-hidden min-h-[400px]`}>
    <div className="absolute top-0 right-0 p-8 mono text-[10px] text-white/10 font-bold tracking-widest">
      PILLAR_{id}
    </div>
    
    <div>
      <div className="w-14 h-14 mb-10 bg-white/5 rounded-2xl flex items-center justify-center text-[#32dee6] group-hover:bg-[#32dee6] group-hover:text-black transition-all duration-500">
        {icon}
      </div>
      <h3 className="text-3xl font-bold mb-4 text-white tracking-tight">{title}</h3>
      <p className="text-gray-400 leading-relaxed mb-12 text-lg font-light">{description}</p>
    </div>

    <div className="pt-8 border-t border-white/5 flex items-center justify-between">
      <div className="space-y-1">
        <p className="mono text-[9px] font-bold text-gray-600 uppercase tracking-widest">System Optimization</p>
        <p className="text-sm font-bold text-[#32dee6]">{metric}</p>
      </div>
      <Link 
        to="/contact" 
        className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center group-hover:bg-white group-hover:text-black transition-all"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg>
      </Link>
    </div>
  </div>
);

const Services: React.FC = () => {
  return (
    <section id="services" className="py-40 px-6 relative bg-[#050505]">
      <div className="container mx-auto">
        <div className="mb-24 space-y-4">
          <div className="mono text-[10px] font-bold text-[#32dee6] tracking-[0.4em] uppercase">Deployment_Matrix_V4</div>
          <h2 className="text-6xl md:text-8xl font-extrabold text-white tracking-tighter uppercase">The Blueprint.</h2>
          <p className="text-xl text-gray-500 max-w-2xl font-light">Three customized pillars designed to scale your business with total predictability.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <ServiceItem 
            id="01"
            title="AI Receptionist"
            description="Build & Deploy in <48 hours. Uses LaunchScript AI (trained on 3M+ calls) to handle FAQs, booking, and objection handling with human-level fidelity."
            metric="48h Deployment"
            icon={<ICONS.Phone />}
          />
          <ServiceItem 
            id="02"
            title="FrontDesk SMS"
            description="Automatic human-like follow-up system for hang-ups and non-bookings. Includes 8-touch workflows and 5-star review filtering logic."
            metric="8-Touch 48h Sequence"
            icon={<ICONS.Zap />}
          />
          <ServiceItem 
            id="03"
            title="24/7 Coverage"
            description="Complete autonomous operation during nights, weekends, and holidays. Full CRM sync and instant summaries for peace of mind."
            metric="Unlimited Uptime"
            icon={<ICONS.Shield />}
          />
        </div>
      </div>
    </section>
  );
};

export default Services;
